import _ from 'lodash';

const analyticsTypes = {
  REQUISITION_VIEW_SELECTIONS: 'requisition_Selections_View',
  REQUISITION_VIEW_REVIEW_ORDER: 'requisition_ReviewOrder_View',
  REQUISITION_ABORT_CONFIRM: 'requisition_Abort_Confirm',
  REQUISITION_ABORT_DISMISS: 'requisition_Abort_Dismiss',
  REQUISITION_SUCCESS: 'requisition_Success'
};

const extractRequisitionValues = checkout => ({
  checkout_id: _.get(checkout, 'id'),
  checkout_status: _.get(checkout, 'status'),
  total_price: _.get(checkout, 'metadata.summary.total.value') / 100,
  subtotal_price: _.get(checkout, 'metadata.summary.subtotal.value') / 100,
  shipping_price: _.get(checkout, 'metadata.summary.shipping.value') / 100,
  tax_price: _.get(checkout, 'metadata.summary.tax.value') / 100,
  total_cash_back: _.get(checkout, 'cart.campaign_discount_overview.campaigns_total_discount') / 100,
  num_items: _.size(_.get(checkout, 'metadata.items'))
});

const extractCheckoutActionValues = (requisition, extra) => ({
  ...extractRequisitionValues(requisition),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.REQUISITION_VIEW_SELECTIONS,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.REQUISITION_VIEW_REVIEW_ORDER,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.REQUISITION_ABORT_CONFIRM,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.REQUISITION_ABORT_DISMISS,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.REQUISITION_SUCCESS,
  attributesExtractor: extractCheckoutActionValues
}];

export {
  analyticsTypes,
  analyticsActions
};
